import {
    CASHLIFTINGLIST_APPROVEREJECT_SUCCESS,
    CASHLIFTINGLIST_APPROVEREJECT_FAILED,
    RESET_CASHLIFTINGLIST_APPROVEREJECT,
    LOADING_CASHLIFTINGLIST_APPROVEREJECT,
    CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CASHLIFTINGLIST_APPROVEREJECT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case CASHLIFTINGLIST_APPROVEREJECT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case CASHLIFTINGLIST_APPROVEREJECT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_CASHLIFTINGLIST_APPROVEREJECT:
            return (state = initialState);
        default:
            return state;
    }
};
